<app-modal [id]="id">
    <span modal-title>{{ "newAtype" | language }}</span>
    <div modal-body>
        <div class="scrolled">
            <div *ngFor="let a of _data.session['atypes']">
                <button *ngIf="_data.turn != null" (click)="changeKind(a.id, a.name)" [ngClass]="_data.turn['prekind_id'] != a.id ? 'btn btn-light w-100 mb-2' : 'btn btn-primary w-100 mb-2'">{{ a.name }}</button>
                <button *ngIf="_data.selectedTurn != null" (click)="changeKind(a.id, a.name)" [ngClass]="_data.selectedTurn['prekind_id'] != a.id ? 'btn btn-light w-100 mb-2' : 'btn btn-primary w-100 mb-2'">{{ a.name }}</button>
            </div>
        </div>
    </div>
</app-modal>
